/**
 * localStorage Keys
 */
const LOCALSTORAGE_KEYS = {
  filtersParameters: 'filtersParameters',
};

export default LOCALSTORAGE_KEYS;
